// extracted by mini-css-extract-plugin
export default {"root":"CreditOrdersSummaryTableRow_root__j1ZtD","progress-value":"CreditOrdersSummaryTableRow_progress-value__x1oTV"};